import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as logger from '../../../logger';
import {
    IconButton,
    Switch,
    Grid,
    Button,
    FormHelperText
} from '@material-ui/core';
import { BiltyTimelineCss as useStyles } from './BiltyCss';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import { UnderlinedEdit, BillIcon } from '../../../components/icons';
import DoneSharpIcon from '@material-ui/icons/DoneSharp';
import { getTripDetailsV3,getJourneyDetails } from '../../../store/actions/tripActionCreator';

const BiltyTimeline = ({ user,selectedTrip,selectedLr,journey,updateJourney, onStepSelect, open, onCheck, dispatchTripDetailsAction }) => {

    const classes = useStyles();

    const [displayCheck, setDisplayCheck] = useState([]);
    const [checkAllTrueValue, setCheckAllTrueValue] = useState(false);

    const biltyStatus = selectedLr && selectedLr.status ? selectedLr.status : {};
    const tripId = selectedTrip && selectedTrip.id ? selectedTrip.id : "";
    let journeyId = journey && journey.id?journey.id:'';
    useEffect(() => {

        dispatchTripDetailsAction(journeyId, () => {
        });

    }, [open]);

    useEffect(() => {

        const check = [];

        for (const key in biltyStatus) {

            if (biltyStatus[key]) {
                check.push(key);
            }

            if (!biltyStatus[key]) {
                check.push(key);
                break;
            }
        }

        setDisplayCheck(check);

        const checkAllTrue = Object.keys(selectedLr.status).every(k => selectedLr.status[k]);

        setCheckAllTrueValue(checkAllTrue);
        onCheck(checkAllTrue);

    }, [user.singleTripData, biltyStatus]);

    const handleDetails = (step) => {
        onStepSelect(step);
    }

    return (
        <>
            <div className={classes.divContainer}>
                <div className={classes.divContainerV1}>
                    <div>
                        <BillIcon className={classes.billIcon} />
                    </div>

                    <div className={classes.mlV1}>
                        <div className={classes.divTitlev1}>Free Online Bilty</div>
                        <div className={classes.divSubTextV1}>Create your free online bilty with us &</div>
                        <div className={classes.divSubTextV2}>document your trip easily</div>
                        {/* <div className={classes.divSubTextV3}>How it works <ArrowRightAltIcon /> </div> */}
                    </div>
                </div>

                <div className={classes.mtV2}>
                    <Timeline classes={{ root: classes.timeLineRootV1 }}>
                        <TimelineItem classes={{ missingOppositeContent: classes.timeLineItem }}>
                            <TimelineSeparator>
                                {!biltyStatus.basic_details &&
                                    <TimelineDot className={classes.dotV1}>
                                        1
                                    </TimelineDot>
                                }
                                {biltyStatus.basic_details &&
                                    <TimelineDot className={classes.dotV2}>
                                        <DoneSharpIcon className={classes.doneIcon} />
                                    </TimelineDot>
                                }
                                <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>
                                <div>
                                    <div className={classes.divTitle}>Company Details</div>
                                    <div className={classes.divSubText}>Your Company Address, contact & GST Number</div>
                                    <div className={classes.mtV1}>
                                        {(displayCheck.includes("basic_details") || checkAllTrueValue) &&
                                            <>
                                                {biltyStatus.basic_details &&
                                                    <div className={classes.divV5}>
                                                        <Button variant="outlined" className={classes.buttonv1} onClick={() => handleDetails('1')}>
                                                            <UnderlinedEdit className={classes.editIcon} /> Edit Company Details
                                                </Button>
                                                    </div>
                                                }
                                                {!biltyStatus.basic_details &&
                                                    <div className={classes.divV5}>
                                                        <Button variant="contained" className={classes.buttonV2} onClick={() => handleDetails('1')}>
                                                            Add Company Details
                                                        </Button>
                                                    </div>
                                                }
                                            </>
                                        }
                                    </div>
                                </div>
                            </TimelineContent>
                        </TimelineItem>

                        <TimelineItem classes={{ missingOppositeContent: classes.timeLineItem }}>
                            <TimelineSeparator>
                                {!biltyStatus.consignor_consignee_details &&
                                    <TimelineDot className={classes.dotV1}>
                                        2
                                    </TimelineDot>
                                }
                                {biltyStatus.consignor_consignee_details &&
                                    <TimelineDot className={classes.dotV2}>
                                        <DoneSharpIcon className={classes.doneIcon} />
                                    </TimelineDot>
                                }
                                <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>
                                <div>
                                    <div className={classes.divTitle}>Consignor Consignee Details</div>
                                    <div className={classes.divSubText}>Name, Address & GST details of Consignor & Consignee </div>
                                    <div className={classes.mtV1}>
                                        {(displayCheck.includes("consignor_consignee_details") || checkAllTrueValue) &&
                                            <>
                                                {biltyStatus.consignor_consignee_details &&
                                                    <div className={classes.divV5}>
                                                        <Button variant="outlined" className={classes.buttonv1} onClick={() => handleDetails('2')} >
                                                            <UnderlinedEdit className={classes.editIcon} /> Edit Consignor / Consignee Details
                                                        </Button>
                                                    </div>
                                                }
                                                {!biltyStatus.consignor_consignee_details &&
                                                    <div className={classes.divV5}>
                                                        <Button variant="contained" className={classes.buttonV2} onClick={() => handleDetails('2')} >
                                                            Add Consignor / Consignee
                                                        </Button>
                                                    </div>
                                                }
                                            </>
                                        }
                                    </div>
                                </div>
                            </TimelineContent>
                        </TimelineItem>

                        <TimelineItem classes={{ missingOppositeContent: classes.timeLineItem }}>
                            <TimelineSeparator>
                                {!biltyStatus.load_details_done &&
                                    <TimelineDot className={classes.dotV1}>
                                        3
                                    </TimelineDot>
                                }
                                {biltyStatus.load_details_done &&
                                    <TimelineDot className={classes.dotV2}>
                                        <DoneSharpIcon className={classes.doneIcon} />
                                    </TimelineDot>
                                }
                                <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent>
                                <div>
                                    <div className={classes.divTitle}>Load & Trip Details</div>
                                    <div className={classes.divSubText}>Add your Load & Trip Details</div>
                                    <div className={classes.mtV1}>
                                        {(displayCheck.includes("load_details_done") || checkAllTrueValue) &&
                                            <>
                                                {
                                                    biltyStatus.load_details_done &&
                                                    <div className={classes.divV5}>
                                                        <Button variant="outlined" className={classes.buttonv1} onClick={() => handleDetails('3')}>
                                                            <UnderlinedEdit className={classes.editIcon} /> Edit Load
                                                        </Button>
                                                    </div>
                                                }
                                                {!biltyStatus.load_details_done &&
                                                    <div className={classes.divV5}>
                                                        <Button variant="contained" className={classes.buttonV2} onClick={() => handleDetails('3')}>
                                                            Add Load
                                                </Button>
                                                    </div>
                                                }
                                            </>
                                        }
                                    </div>
                                </div>
                            </TimelineContent>
                        </TimelineItem>

                        <TimelineItem classes={{ missingOppositeContent: classes.timeLineItem }}>
                            <TimelineSeparator>
                                {!biltyStatus.insurance_signature_details_done &&
                                    <TimelineDot className={classes.dotV1}>
                                        4
                                    </TimelineDot>
                                }
                                {biltyStatus.insurance_signature_details_done &&
                                    <TimelineDot className={classes.dotV2}>
                                        <DoneSharpIcon className={classes.doneIcon} />
                                    </TimelineDot>
                                }
                            </TimelineSeparator>
                            <TimelineContent>
                                <div>
                                    <div className={classes.divTitle}>Insurance & Signature</div>
                                    <div className={classes.divSubText}>Add insurance & waybill details</div>
                                    <div className={classes.mtV1}>
                                        {(displayCheck.includes("insurance_signature_details_done") || checkAllTrueValue) &&
                                            <>
                                                {biltyStatus.insurance_signature_details_done &&
                                                    <Button variant="outlined" className={classes.buttonv1} onClick={() => handleDetails('4')} >
                                                        <UnderlinedEdit className={classes.editIcon} /> Edit Insurance & Signature
                                                    </Button>
                                                }
                                                {!biltyStatus.insurance_signature_details_done &&
                                                    <Button variant="contained" className={classes.buttonV2} onClick={() => handleDetails('4')} >
                                                        Add Insurance & Signature
                                                    </Button>
                                                }
                                            </>
                                        }
                                    </div>
                                </div>
                            </TimelineContent>
                        </TimelineItem>
                    </Timeline>

                </div>

            </div>
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchTripDetailsAction: (tripId, onSuccess, onError) =>
        dispatch(getJourneyDetails(tripId, onSuccess, onError))
});

export default connect(mapStateToProps, mapDispatchToProps)(BiltyTimeline);